import { call, select, put, takeLatest } from 'redux-saga/effects';
import {
  IMPORT_EVENTS,
  SHOW_NOTIFY,
  NOTIFY_LEVEL,
  RequestStatus,
} from 'constants';
import AppUtils from '@control-front-end/utils/utils';
import api from '@control-front-end/common/sagas/api';

/**
 * Импорт событий из файла
 */
function* uploadFile({ payload: file }) {
  const accounts = yield select((state) => state.accounts);
  const { result } = yield call(api, {
    method: 'post',
    url: `/events_upload/${accounts.active}`,
    body: { file: file[0].fileSource },
    reqType: 'multipart',
  });
  if (result !== RequestStatus.SUCCESS) return false;

  yield put({
    type: SHOW_NOTIFY.REQUEST,
    payload: {
      id: AppUtils.createRid(),
      type: NOTIFY_LEVEL.SUCCESS,
      label:
        'Import of events is in line. We will notify you of the import status',
    },
  });
}

function* importEvents() {
  yield takeLatest(IMPORT_EVENTS.REQUEST, uploadFile);
}

export default importEvents;
